var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrezor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 166,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "svg_3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "svg_4",
    width: 166,
    height: 166,
    rx: 16,
    fill: "#ffffff",
    y: 0,
    x: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_1",
    fill: "none",
    fillRule: "evenodd",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m53.11382,58.63842l0,-8.83496c0,-17.04132 13.81472,-30.85604 30.85604,-30.85604c17.04132,0 30.85604,13.81472 30.85604,30.85604l0,8.83496l12.91042,0l0,67.68291l-43.38077,20.67867l-44.35556,-20.67867l0,-67.68291l13.11382,0l0.00001,0zm15.42802,0l30.85604,0l0,-8.83496l-0.02481,0c-0.45727,-8.17197 -7.17869,-14.65662 -15.40321,-14.65662c-8.22452,0 -14.94594,6.48465 -15.40321,14.65662l-0.02481,0l0,8.83496zm-10.79962,15.84988l0,40.88426l26.12594,12.31681l26.32934,-12.31681l0,-40.88426l-52.45528,0z",
    id: "svg_2",
    fill: "currentColor",
    stroke: "null"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrezor);
export default __webpack_public_path__ + "static/media/trezor.014f0756510060f44313b970a58623de.svg";
export { ForwardRef as ReactComponent };